import moment from "moment"
import React, { useState } from "react"
import { CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"
import IconCheckbox from '../../../assets/images/icon-checkbox.png';
import IconCheckboxActive from '../../../assets/images/icon-checkbox-active.png';

const ProductPrice = (props: any) => {
    const { data, type, onlyView, handleChangeInput, validation} = props

    return (
        <PageBody>
            <div className="nutri-title mb-3">Giá sản phẩm</div>
            <Row>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Giá nhập</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "price_import" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price_import'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.price_import ? '---': data?.price_import}
                                placeholder={(type=='view' && !data?.price_import) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Giá bán lẻ</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "price" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.price ? '---': data?.price}
                                placeholder={(type=='view' && !data?.price) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                            {validation?.price &&<div className="invalid-feedback d-block" >{validation?.price}</div>}
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Bán buôn</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeInput({target:{ name: "price_wholesale" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price_wholesale'} type={'text'} className="form-control" 
                                value={type === 'view' && !data?.price_wholesale ? '---': data?.price_wholesale}
                                placeholder={(type=='view' && !data?.price_wholesale) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className={type != 'view' ? 'nutri-form placeholder-right1' : 'nutri-form'}>
                        <div className="d-flex align-items-center">
                            <Row style={{width:'100%'}}>
                                <Col xl={12}>
                                    <div className="nutri-checkbox" onClick={() => type =='view' ? {} : handleChangeInput({target:{ name: "vat_enable" , value: data?.vat_enable ? false: true }})}>
                                        <div className="icon">
                                            {data?.vat_enable ?
                                            <img src={IconCheckboxActive} alt="icon" />:    
                                            <img src={IconCheckbox} alt="icon" />  
                                            }
                                        </div>
                                        <div className="label">Áp dụng thuế</div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {data?.vat_enable &&
                        <>
                            <Label>Giá trị thuế</Label>
                            <InputGroup className='nutri-form form-group'>
                                <NumberFormat 
                                    disabled={onlyView}
                                    onChange={(e: any) => handleChangeInput({target:{ name: "vat" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                    name={'vat'} type={'text'} className="form-control" 
                                    value={type === 'view' && !data?.vat ? '---': data?.vat}
                                    placeholder={(type=='view' && !data?.vat) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                />
                            </InputGroup>
                            <div className="unit" style={{zIndex: 9}}>%</div>
                        </>}
                    </FormGroup>
                </Col>
            </Row>
        </PageBody>
    )
}

export default ProductPrice